import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { Instance } from '../../@types/instance';
import { setSelectedInstance } from './instance.actions';

export interface InstanceState {
    selectedInstance: Instance | undefined;
}

export const defaultState: InstanceState = {
    selectedInstance: undefined,
};

export default reducerWithInitialState(defaultState).case(
    setSelectedInstance,
    (state, payload) => ({
        ...state,
        selectedInstance: payload,
    })
);
